module.exports = __webpack_public_path__ + "img/home-right2.a27be08b.png";